export const TablePaginationOptions = [5, 10, 25, 50];
